// extracted by mini-css-extract-plugin
module.exports = {"cancellationRefundAmount":"Summary_cancellationRefundAmount__1X_DZ"};